import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Link } from "react-router-dom";
import axios from 'axios';
import mainlogo from '..//img/main_logo_interpartner.png';

//Bootstrap
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import ListGroup from 'react-bootstrap/ListGroup';
import Modal from 'react-bootstrap/Modal';

//FontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock } from '@fortawesome/free-solid-svg-icons'
import { faUser } from '@fortawesome/free-solid-svg-icons'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'

//Google Recaptcha
import ReCAPTCHA from "react-google-recaptcha";

//Context
import ApiRootContext from './ApiRootContext';

//MFA
import { QRCodeCanvas } from "qrcode.react";
export class Login extends Component {
    static displayName = Login.name;

    constructor(props) {
        super(props);
        this.state = {
            loginClasses: "fa-spin ml-2 d-none",
            loginMessageClasses: "d-none",
            passwordResetMessageClasses: "d-none",
            loginBtnDisabled: false,
            loginResponse: {},
            passwordResetResponse: {},
            userName: "",
            password: "",
            email: "",
            showResetPassowrdModal: false,
            reCAPTCHAToken: "",

            // MFA
            mfaStep: "credentials",
            mfaCode: "",
            mfaSecret: "",
            mfaOtpauthUrl: "",
            mfaLoading: false
        };
        this.Login = this.Login.bind(this);
        this.ResetPassword = this.ResetPassword.bind(this);

        //MFA
        this.GenerateMfaSetup = this.GenerateMfaSetup.bind(this);
        this.ConfirmMfa = this.ConfirmMfa.bind(this);
        this.VerifyMfa = this.VerifyMfa.bind(this);
    }

    ResetPassowrdModalClose() {
        this.setState({ showResetPassowrdModal: false });
    }

    ResetPassowrdModalOpen() {
        this.setState({ showResetPassowrdModal: true });
    }

    HandleChange(evt) {
        const value = evt.target.value;
        this.setState({ [evt.target.name]: value });
    }

    HandleReCAPTCHAChagne(value) {
        this.setState({ reCAPTCHAToken: value });
    }

    async Login(APIRoot) {
        this.setState({
            loginClasses: "fa-spin ml-2",
            loginBtnDisabled: true,
            redirectURL: ""
        });

        const request = {
            UserName: this.state.userName,
            Password: this.state.password,
            reCAPTCHAToken: this.state.reCAPTCHAToken
        }

        axios.post("api/user/login", request)
            .then(res => {
                if (res.data.isSuccess) {

                    const data = res.data.data;

                    // MFA gerekiyorsa henüz token oluşturulmadı.
                    if (data.twoFARequired) {

                        // MFA kurulumu gerekiyorsa
                        if (data.mfaSetupRequired) {
                            this.setState({
                                mfaStep: "mfa-setup",
                                mfaCode: "",
                                loginClasses: "fa-spin ml-2 d-none",
                                loginBtnDisabled: false,
                                loginResponse: res.data
                            });

                            this.GenerateMfaSetup();
                        }
                        // MFA zaten kuruluysa
                        else {
                            this.setState({
                                mfaStep: "mfa",
                                mfaCode: "",
                                loginClasses: "fa-spin ml-2 d-none",
                                loginBtnDisabled: false,
                                loginResponse: res.data
                            });
                        }

                        return;
                    }

                    // MFA aktif değilse eski login davranışı
                    window.sessionStorage.setItem("userID", data.userID);

                    window.sessionStorage.setItem("userToken", data.userAccessToken);

                    window.sessionStorage.setItem("isProvider", data.isProvider);

                    this.setState({ loginMessageClasses: "d-none mb- 3", loginResponse: res.data });

                    this.props.authCheck();

                    if (data.isProvider)
                        this.setState({ redirectURL: '/UnprocessedServices' });
                    else
                        this.setState({ redirectURL: '/InsuranceServices' });
                }
                else {
                    this.setState({
                        loginClasses: "fa-spin ml-2 d-none",
                        loginBtnDisabled: false,
                        loginResponse: res.data,
                        loginMessageClasses: "mb-3"
                    });
                }
            });
    }

    async ResetPassword() {
        const request = {
            UserName: this.state.userName,
            UserEmail: this.state.email,
            reCAPTCHAToken: this.state.reCAPTCHAToken
        }

        axios.post("api/user/resetpassword", request)
            .then(res => {
                this.setState({
                    passwordResetMessageClasses: "mb-3",
                    passwordResetResponse: res.data
                });
            });
    }
    async GenerateMfaSetup() {
        this.setState({ mfaLoading: true, loginClasses: "fa-spin ml-2" });

        const request = {
            UserName: this.state.userName,
            Password: this.state.password,
            Code: "",
            Secret: ""
        };

        try {
            const res = await axios.post("api/user/generate-mfa-setup", request);

            if (res.data.isSuccess) {

                const data = res.data.data;
                console.log("MFA SETUP RESPONSE:", res.data);
                console.log("MFA SETUP DATA:", res.data.data);
                this.setState({
                    mfaSecret: data.secret,
                    mfaOtpauthUrl: data.otpauthUrl,
                    mfaLoading: false,
                    loginClasses: "fa-spin ml-2 d-none"
                });

            } else {

                this.setState({
                    mfaLoading: false,
                    loginClasses: "fa-spin ml-2 d-none",
                    loginBtnDisabled: false,
                    loginResponse: res.data,
                    loginMessageClasses: "mb-3"
                });
            }
        }
        catch (error) {

            this.setState({
                mfaLoading: false,
                loginClasses: "fa-spin ml-2 d-none",
                loginBtnDisabled: false,
                loginMessageClasses: "mb-3",
                loginResponse: {
                    isSuccess: false, message: "MFA kurulumu sırasında bir hata oluştu."
                }
            });
        }
    }

    async ConfirmMfa() {
        this.setState({ mfaLoading: true });

        const request = {
            UserName: this.state.userName,
            Password: this.state.password,
            Code: this.state.mfaCode,
            Secret: this.state.mfaSecret
        };

        try {
            const res = await axios.post("api/user/confirm-mfa", request);

            if (res.data.isSuccess) {

                const data = res.data.data;

                // Token bilgilerini normal login gibi kaydet
                window.sessionStorage.setItem("userID", data.userID);

                window.sessionStorage.setItem("userToken", data.userAccessToken);

                window.sessionStorage.setItem("isProvider", data.isProvider);

                this.setState({
                    mfaLoading: false,
                    mfaStep: "credentials",
                    mfaCode: "",
                    loginResponse: res.data,
                    loginMessageClasses: "d-none"
                });

                this.props.authCheck();

                if (data.isProvider) {
                    this.setState({ redirectURL: "/UnprocessedServices" });
                }
                else {
                    this.setState({ redirectURL: "/InsuranceServices" });
                }

            }
            else {

                this.setState({
                    mfaLoading: false,
                    loginResponse: res.data,
                    loginMessageClasses: "mb-3"
                });
            }
        }
        catch (error) {

            this.setState({
                mfaLoading: false,
                loginResponse: {
                    isSuccess: false,
                    message: "MFA doğrulaması sırasında bir hata oluştu."
                },
                loginMessageClasses: "mb-3"
            });
        }
    }

    async VerifyMfa() {
        this.setState({ mfaLoading: true });

        const request = {
            UserName: this.state.userName,
            Password: this.state.password,
            Code: this.state.mfaCode,
            Secret: ""
        };

        try {
            const res = await axios.post("api/user/verify-mfa", request);

            if (res.data.isSuccess) {

                const data = res.data.data;

                // Token bilgilerini normal login gibi kaydet
                window.sessionStorage.setItem("userID", data.userID);

                window.sessionStorage.setItem("userToken", data.userAccessToken);

                window.sessionStorage.setItem("isProvider", data.isProvider);

                this.setState({
                    mfaLoading: false,
                    mfaStep: "credentials",
                    mfaCode: "",
                    loginResponse: res.data,
                    loginMessageClasses: "d-none"
                });

                this.props.authCheck();

                if (data.isProvider) {
                    this.setState({ redirectURL: "/UnprocessedServices" });
                }
                else {
                    this.setState({ redirectURL: "/InsuranceServices" });
                }

            }
            else {

                this.setState({
                    mfaLoading: false,
                    loginResponse: res.data,
                    loginMessageClasses: "mb-3"
                });
            }
        }
        catch (error) {

            this.setState({
                mfaLoading: false,
                loginResponse: { isSuccess: false, message: "MFA doğrulaması sırasında bir hata oluştu." },
                loginMessageClasses: "mb-3"
            });
        }
    }

    render() {
        if (this.state.redirectURL) {
            return <Redirect to={this.state.redirectURL} />
        }
        return (
            <>
                <Row className="justify-content-center mt-2">
                    <Col md={6}>
                        <Card>
                            <Card.Header>
                                <Row>
                                    <Col xs={3}>
                                        <img
                                            alt=""
                                            src={mainlogo}
                                            width="70"
                                            height="70"
                                            className="d-inline-block align-top"
                                        />
                                    </Col>
                                    <Col xs={9}>
                                        <h1 className="mt-2">IPAEksper</h1>
                                    </Col>
                                </Row>
                            </Card.Header>
                            <Card.Body>
                                {this.state.mfaStep === "mfa-setup" && (
                                    <div className="mfa-setup-container">

                                        <h4>Google Authenticator Kurulumu</h4>

                                        <p>Google Authenticator uygulamasını açın ve aşağıdaki QR kodu taratın.</p>

                                        {this.state.mfaOtpauthUrl && (
                                            <div className="text-center mb-3">
                                                <QRCodeCanvas value={this.state.mfaOtpauthUrl} size={200} />
                                            </div>
                                        )}

                                        <p>QR kodu tarattıktan sonra uygulamadaki 6 haneli kodu girin.</p>

                                        <input
                                            type="text"
                                            className="form-control"
                                            maxLength="6"
                                            value={this.state.mfaCode}
                                            onChange={(e) => this.setState({ mfaCode: e.target.value.replace(/\D/g, "") })}
                                            placeholder="6 haneli kod"
                                        />

                                        <button
                                            type="button"
                                            className="btn btn-primary mt-3"
                                            disabled={
                                                this.state.mfaLoading ||
                                                this.state.mfaCode.length !== 6
                                            }
                                            onClick={this.ConfirmMfa}
                                        >
                                            {this.state.mfaLoading
                                                ? "Doğrulanıyor..."
                                                : "MFA Doğrula"}
                                        </button>

                                        {this.state.mfaSecret && (
                                            <div className="mt-3">
                                                <small>QR kod okunamıyorsa manuel anahtar:</small>
                                                <div>
                                                    <strong>{this.state.mfaSecret}</strong>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                                {this.state.mfaStep === "mfa" && (
                                    <div className="mfa-container">

                                        <h4>Google Authenticator Kodu</h4>

                                        <p>Google Authenticator uygulamanızdaki 6 haneli kodu girin.</p>
                                        {this.state.loginResponse && !this.state.loginResponse.isSuccess && this.state.loginResponse.message && (<div className="alert alert-danger mb-3"> {this.state.loginResponse.message} </div>)}
                                        <input
                                            type="text"
                                            className="form-control"
                                            maxLength="6"
                                            value={this.state.mfaCode}
                                            onChange={(e) =>
                                                this.setState({
                                                    mfaCode: e.target.value.replace(/\D/g, "")
                                                })
                                            }
                                            placeholder="6 haneli kod"
                                        />

                                        <button
                                            type="button"
                                            className="btn btn-primary mt-3"
                                            disabled={
                                                this.state.mfaLoading ||
                                                this.state.mfaCode.length !== 6
                                            }
                                            onClick={this.VerifyMfa}
                                        >
                                            {this.state.mfaLoading
                                                ? "Doğrulanıyor..."
                                                : "Giriş Yap"}
                                        </button>

                                    </div>
                                )}
                                {this.state.mfaStep === "credentials" && (
                                    <Form id="loginForm" name="loginForm">
                                        <Row className={this.state.loginMessageClasses}>
                                            <Col>
                                                <ListGroup>
                                                    <ListGroup.Item variant="primary">
                                                        <span>{this.state.loginResponse.message}</span>
                                                    </ListGroup.Item>
                                                </ListGroup>
                                            </Col>
                                        </Row>
                                        <Form.Group as={Row} className="justify-content-center mb-0">
                                            <Col sm="12">
                                                <InputGroup className="mb-0">
                                                    <InputGroup.Prepend>
                                                        <InputGroup.Text className="rounded-0">
                                                            <FontAwesomeIcon icon={faUser} />
                                                        </InputGroup.Text>
                                                    </InputGroup.Prepend>
                                                    <Form.Control name="userName" autoComplete="off" className="rounded-0" placeholder="Kullanıcı Adı" onChange={e => this.HandleChange(e)} />
                                                </InputGroup>
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className="justify-content-center">
                                            <Col sm="12">
                                                <InputGroup className="mb-0">
                                                    <InputGroup.Prepend>
                                                        <InputGroup.Text className="rounded-0">
                                                            <FontAwesomeIcon icon={faLock} />
                                                        </InputGroup.Text>
                                                    </InputGroup.Prepend>
                                                    <Form.Control name="password" className="rounded-0" type="password" placeholder="Şifre" onChange={e => this.HandleChange(e)} />
                                                </InputGroup>
                                            </Col>
                                        </Form.Group>
                                        <ReCAPTCHA className="mb-3" sitekey="6Lcz3YUUAAAAAA7XW9HSm6jUFDoDkGkouBebgDH_" onChange={value => this.HandleReCAPTCHAChagne(value)} />
                                        <ApiRootContext.Consumer>
                                            {(apiRoot) =>
                                                <Button name="btnLogin" id="btnLogin" variant="primary" disabled={this.state.loginBtnDisabled} onClick={() => this.Login({ apiRoot })} >
                                                    Giriş Yap
                                                    <FontAwesomeIcon className={this.state.loginClasses} icon={faCircleNotch} />
                                                </Button>}
                                        </ApiRootContext.Consumer>
                                        <span> veya </span>
                                        <Button className="p-0 m-0 pb-1" variant="link" onClick={() => this.ResetPassowrdModalOpen()}>şifremi unuttum</Button>
                                    </Form>
                                )}
                            </Card.Body>
                            <Card.Footer>
                                Inter Partner Assistance - <Link to="/privacypolicy">Gizlilik Politikası</Link>
                            </Card.Footer>
                        </Card>
                    </Col>
                </Row>
                <Modal show={this.state.showResetPassowrdModal} onHide={() => this.ResetPassowrdModalClose()}>
                    <Modal.Header closeButton>
                        <Modal.Title>Şifre Talebi</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row className={this.state.passwordResetMessageClasses}>
                            <Col>
                                <ListGroup>
                                    <ListGroup.Item variant="primary" >
                                        <span>{this.state.passwordResetResponse.message}</span>
                                    </ListGroup.Item>
                                </ListGroup>
                            </Col>
                        </Row>
                        <Form.Group as={Row} className="justify-content-center mb-0">
                            <Col sm="12">
                                <InputGroup className="mb-0">
                                    <InputGroup.Prepend>
                                        <InputGroup.Text className="rounded-0">
                                            <FontAwesomeIcon icon={faUser} />
                                        </InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control name="userName" className="rounded-0" placeholder="Kullanıcı Adı" onChange={e => this.HandleChange(e)} />
                                </InputGroup>
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="justify-content-center">
                            <Col sm="12">
                                <InputGroup className="mb-0">
                                    <InputGroup.Prepend>
                                        <InputGroup.Text className="rounded-0">
                                            <FontAwesomeIcon icon={faEnvelope} />
                                        </InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control name="email" className="rounded-0" placeholder="Email Adresi" onChange={e => this.HandleChange(e)} />
                                </InputGroup>
                            </Col>
                        </Form.Group>
                        <ReCAPTCHA className="mb-3" sitekey="6Lcz3YUUAAAAAA7XW9HSm6jUFDoDkGkouBebgDH_" onChange={value => this.HandleReCAPTCHAChagne(value)} />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.ResetPassowrdModalClose()}>
                            Kapat
                        </Button>
                        <Button variant="primary" onClick={() => this.ResetPassword()}>
                            Şifre Yenile
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}
